import template from './passenger-lifts.jade';

export default angular
    .module('cian.addForm.passengerLifts', [])
    .directive('cianAfAboutBuildingPassengerLifts', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.values = [
                { name: 'нет', key: undefined },
                { name: '1', key: 1 },
                { name: '2', key: 2 },
                { name: '3', key: 3 },
                { name: '4', key: 4 },
            ];
        },
        controllerAs: 'passengerLifts',
        template,
    }))
    .name;
